const rankings = [
  {
    rank: 1,
    title: '长安三万里2',
    category: '动画电影',
    hot: '本周播放量 1,286万',
    trend: 'up',
    icon: 'ri-fire-line',
    color: 'text-accent-500',
  },
  {
    rank: 2,
    title: '信号2',
    category: '韩剧',
    hot: '本周播放量 1,052万',
    trend: 'up',
    icon: 'ri-arrow-up-line',
    color: 'text-primary-500',
  },
  {
    rank: 3,
    title: '射雕英雄传',
    category: '国产剧',
    hot: '本周播放量 968万',
    trend: 'up',
    icon: 'ri-arrow-up-line',
    color: 'text-primary-500',
  },
  {
    rank: 4,
    title: '深海2',
    category: '动画电影',
    hot: '本周播放量 875万',
    trend: 'new',
    icon: 'ri-sparkling-line',
    color: 'text-secondary-500',
  },
  {
    rank: 5,
    title: '漫长的季节',
    category: '悬疑剧',
    hot: '本周播放量 792万',
    trend: 'steady',
    icon: 'ri-subtract-line',
    color: 'text-foreground-400',
  },
];

export default function RankingSection() {
  const rankColors: Record<number, string> = {
    1: 'bg-accent-500 text-background-50',
    2: 'bg-primary-500 text-background-50',
    3: 'bg-secondary-500 text-background-50',
    4: 'bg-foreground-300 text-background-50',
    5: 'bg-foreground-200 text-foreground-700',
  };

  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热播榜单</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">本周最受欢迎的影视作品，大家都在看这些</p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankings.map((item, idx) => (
            <a
              key={idx}
              href="#carousel"
              className="flex items-center gap-4 p-4 rounded-lg hover:bg-background-100 transition-colors cursor-pointer no-underline border-b border-background-200/50 last:border-0"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold shrink-0 ${rankColors[item.rank]}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm md:text-base font-heading font-bold text-foreground-900 whitespace-nowrap">{item.title}</span>
                  <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">{item.category}</span>
                </div>
                <div className="flex items-center gap-2 mt-1">
                  <i className={`${item.icon} text-xs ${item.color}`}></i>
                  <span className="text-xs text-foreground-400">{item.hot}</span>
                </div>
              </div>
              <div className="w-7 h-7 flex items-center justify-center shrink-0">
                <i className="ri-play-circle-line text-lg text-foreground-300 hover:text-primary-500 transition-colors"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}